import { PromptGeneratorApiClient } from './PromptGeneratorApiClient';
import PromptGeneratorApiService from './PromptGeneratorApiService';

const chatgptApiClient = new PromptGeneratorApiClient();
export const PromptGeneratorService = new PromptGeneratorApiService(chatgptApiClient);
